import {
    useState,
    useEffect,
    useCallback,
    ChangeEventHandler,
    KeyboardEventHandler,
    MouseEvent,
} from 'react';
import { useStore } from '@ui/hooks/useStore';
import useKeyDown from '@ui/hooks/useKeyDown';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';
import { IState } from './IState';

const useLogin = (onClose: ICloseEvent['onClose']) => {    
    const { user, app, lang, modal } = useStore();
    const key = useKeyDown();
    
    const initState: IState = {
        login: '',
        password: '',
        toConfrimPage: false,
        loginError: false,
        passwordError: false,
        passRecoveryVisible: false,
        dataFetch: [],
    };
    
    const [state, setState] = useState(initState)
    
    const loginValidate = (login: string) => {
        if (!login) {
            setState((prev) => ({
                ...prev,
                loginError: true,
            }));
            return false;
        } else {
            setState((prev) => ({
                ...prev,
                loginError: false,
            }));
            return true;
        }
        
    };
    const passwordValidate = (password: string) => {
        if (!password || password.length < 8) {
            setState((prev) => ({
                ...prev,
                passwordError: true,
            }));
            return false;
        } else {
            setState((prev) => ({
                ...prev,
                passwordError: false,
            }));
            return true;
        }
    };
    const handleInputClick = () => {
        user.resetAuthError();
        user.resetRegisterError();
        user.resetServerError();
        setState((prev) => ({
            ...prev,
            loginError: false,
            passwordError: false,
        }));
    };
    const handleLoginChange: ChangeEventHandler<HTMLInputElement> = useCallback(
        (e) => {
            const login = e.target.value;
            setState((prev) => ({
                ...prev,
                login,
                loginError: false,
                passwordError: false,
            }));
        },
        [],
    );
    const handlePasswordChange: ChangeEventHandler<HTMLInputElement> =
        useCallback((e) => {
            const password = e.target.value;
            setState((prev) => ({
                ...prev,
                password,
                loginError: false,
                passwordError: false,
            }));
        }, []);

    const handleSignInClick = useCallback(
        (e?: MouseEvent<HTMLButtonElement>) => {            
            if (e) e.preventDefault();
            const { login, password } = state;
            const isLoginValid = loginValidate(login);
            const isPasswordValid = passwordValidate(password);
            user.resetAuthError();
            user.resetRegisterError();
            user.resetServerError();
            if (isLoginValid && isPasswordValid) {
                setState((prev) => ({
                    ...prev,
                    toConfrimPage: true,
                }));
                user.loginOldAccount(login, password);
                //app.isOldLogin = true;
                app.isOpenModalAddOldDevice = true; 
                user.loginOldActivated = true;
                //user.groupNameOldlogin = login;              
            }
        },
        [state.login, state.password]
    );

    const handleRegisterOpen = useCallback(() => {
        modal.openRegister();
    }, []);

    const handlePassRecoveryOpen = useCallback(() => {
        modal.openPasswordRecovery();
    }, []);

    const handleKey = (key: string) => {
        switch (key) {
            case 'Escape':
                onClose();
                break;
            case 'Enter':
                handleSignInClick();
                break;
        }
    };

    const handleKeyDown: KeyboardEventHandler<HTMLInputElement> = (e) => {
        const { key } = e;
        if (key === 'Enter') {
            e.stopPropagation();
            e.preventDefault();
            handleKey(key);
        }
    };
    const handleBtnKeyDown: KeyboardEventHandler<HTMLInputElement> = (e) => {
        const { key } = e;
        if (key === 'Enter') {
            e.stopPropagation();
            e.preventDefault();
            const target = e.target as HTMLInputElement;
            target.click();
        }
    };
    const handlers = {
        handleLoginChange,
        handlePasswordChange,
        handleSignInClick,
        handleInputClick,
        handleBtnKeyDown,
        handleKeyDown,
        handleRegisterOpen,
        handlePassRecoveryOpen,
    };

    useEffect(() => {
        user.resetAuthError();
        user.resetRegisterError();
        user.resetServerError();
    }, []);

    useEffect(() => {
        handleKey(key);
    }, [key]);

    useEffect(() => {
        if (user.operationSuccessOldPass) {
            onClose()
            user.operationSuccessOldPass = false;
        }
        
    })

    return {
        user,
        lang,
        state,
        handlers,
    };
};

export default useLogin;
